import { Card } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import React from 'react';
import { ImageService } from '../../../main/services/ImageService/ImageService';
import FullScreenWrapperWithBranchLogo from '../FullScreenWrapperWithBranchLogo';
import { useStyles } from './ScreenEmailSent.styles';

const IMAGE_EMAIL_SENT_FILE_LOCATION = '/static/images/loggedout/img_email_sent.svg';

export const ScreenEmailSent = () => {
  const { card, cardContent, cardTitle, image, verifyEmailTextBlock, mainText } = useStyles();

  return (
    <FullScreenWrapperWithBranchLogo>
      <Card className={card}>
        <div className={cardContent}>
          <div className={cardTitle} data-testid="email-sent--header-title">
            Email sent!
          </div>
          <img
            className={image}
            data-testid="email-sent--header-image"
            src={ImageService.getImageUrl(IMAGE_EMAIL_SENT_FILE_LOCATION)}
          />
          <p className={cx(mainText, verifyEmailTextBlock)}>
            Verification link has been successfully sent to your email. Please make sure that you check your inbox and spam
            folder.
          </p>
        </div>
      </Card>
    </FullScreenWrapperWithBranchLogo>
  );
};
